import { createFileRoute } from '@tanstack/react-router';
import { ResultsLayout } from '../-components/evaluate/ResultsLayout';

export const Route = createFileRoute('/_app/simops/$studyId/results')({
  component: ResultsLayout,
});
